<div class="position-relative">
    <div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom px-4 py-3 secondary-nav" style="position: fixed; top:65px; z-index:5;">
        <div class="d-flex flex-column col">
            <h3 class="mt-0 mb-1">Add Company</h3>
            <p-breadcrumb [model]="items"></p-breadcrumb>
        </div>
        <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
            <button pButton pRipple type="button" label="Clear All" class="p-button-outlined p-button-secondary me-3"></button>
            <button pButton pRipple type="button" label="Save Company"></button>
        </div>
    </div>
</div>

<div style="padding-top:72px;">
    <div class="p-white shadow m-3 p-4">
        <div class="col-12 col-sm-12">
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="d-flex flex-column">
                        <label class="mb-2">Company Name *</label>
                        <input type="text" pInputText> 
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6 mb-lg-0 mb-md-4">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Company Registration Number *</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Vat Number *</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6 ">
                            <div class="d-flex flex-column ">
                                <label class="mb-2">Company Registered date *</label>
                                <p-calendar dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" [showIcon]="true" inputId="icon" styleClass="company-reg-date"></p-calendar>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 d-flex align-items-center">
                            <div class="d-flex flex-row align-items-center">
                                <label class="mt-2">Mark as a parent Company</label>
                                <p-inputSwitch styleClass="mt-3 mx-3"[(ngModel)]="checked"></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="d-flex flex-column">
                        <label class="mb-2">Address Line 1</label>
                        <input type="text" pInputText> 
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="d-flex flex-column">
                        <label class="mb-2">Address Line 2</label>
                        <input type="text" pInputText> 
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="d-flex flex-column">
                        <label class="mb-2">Address Line 3</label>
                        <input type="text" pInputText> 
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6">
                            <div class="d-flex flex-column">
                                <label class="mb-2">City *</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6">
                            <div class="d-flex flex-column">
                                <label class="mb-2">State *</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Postal Code *</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Country *</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="d-flex flex-column">
                        <label class="mb-2">Operational Group(s) *</label>
                        <p-dropdown placeholder="Select Operational Group"  optionLabel="name"></p-dropdown>
                    </div>
                </div>
            </div>
        </div>


        
    </div>
</div>


